import { rule } from '../../domain/badge-composition-rule.js';
import { i18n } from '../../domain/i18n.js';

/**
 * @param {BadgeComposition} composition
 * @returns {BadgeCompositionRule[]}
 */
export const defaultRules = composition => {
  return [
    rule('default')
      .byDefault()
      .set(() => ({
        aspect: {
          type: 'collapsed'
        },
        constraints: {
          canMaximize: true
        },
        parts: {
          accordion: {
            size: 'md'
          },
          menu: {
            show: true,
            placement: 'external',
            extraOffsetRight: 0,
            zIndex: composition.aspect.baseZIndex + 300
          },
          carousel: {
            show: true,
          },
          contents: {
            present: true,
            texts: {
              originalityConfirmedTitle: i18n.contents.texts.originalityConfirmedTitle,
              originalityConfirmedText: i18n.contents.texts.originalityConfirmedText,
              authRetailerTitle: i18n.contents.texts.authRetailerTitle,
              authRetailerText: i18n.contents.texts.authRetailerText,
              shopCheckTitle: i18n.contents.texts.shopCheckTitle,
              shopCheckText: i18n.contents.texts.shopCheckText
            }
          },
          sealAsButton: {
            show: false
          },
          shadowZone: {
            show: false
          },
          maximizeArrow: {
            show: false
          },
          headerImage: {
            show: false
          },
          aubySeal: {
            show: false,
            imageSrc: 'authorized-by-badge.svg',
          },
          tuvSeal: {
            show: false,
            imageSrc: 'tuev-badge.svg',
          },
          tooltips: {
            show: true,
            zIndex: composition.aspect.baseZIndex + 400,
          }
        }
      })),
  ];
};
